import { throttle } from './helper'

export class Screenmode {
  constructor (settings = {}) {
    const breakpointDefaults = {}

    this.breakpointNames = [
      'xl',
      'lg',
      'md',
      'sm',
      'xs'
    ]

    breakpointDefaults[this.breakpointNames[0]] = 1200
    breakpointDefaults[this.breakpointNames[1]] = 992
    breakpointDefaults[this.breakpointNames[2]] = 768
    breakpointDefaults[this.breakpointNames[3]] = 576
    breakpointDefaults[this.breakpointNames[4]] = 0

    this.breakpoints = $.extend(breakpointDefaults, settings)
  }

  init () {
    this.setBreakpointClass($('html'), true)
  }

  /**
   * Returns the current breakpoint name
   * @returns {string}
   */
  getCurrentBreakpoint () {
    const that = this
    let name = ''
    const width = $(document).width()

    for (let i = that.breakpointNames.length; i >= 0; i -= 1) {
      let nextBreakpoint = 9999
      if (typeof that.breakpointNames[i - 1] !== 'undefined') {
        nextBreakpoint = that.breakpoints[that.breakpointNames[i - 1]]
      }

      if (width >= that.breakpoints[that.breakpointNames[i]] && width < nextBreakpoint) {
        name = that.breakpointNames[i]
      }
    }

    return name
  }

  /**
   * Set breakpoint class to $element.
   * If live is true the breakpoint class is set on window resize.
   * @param $element
   * @param live
   * @returns {boolean}
   */
  setBreakpointClass ($element, live = false) {
    const that = this
    const currentBreakpoint = that.getCurrentBreakpoint()

    $.each(that.breakpointNames, function (i, value) {
      if (currentBreakpoint !== value) {
        $element.removeClass(value)
      }
    })

    $element.addClass(that.getCurrentBreakpoint())

    if (!live) {
      return false
    }

    $(window).resize(throttle(function () {
      const currentBreakpoint = that.getCurrentBreakpoint()

      $.each(that.breakpointNames, function (i, value) {
        if (currentBreakpoint !== value) {
          $element.removeClass(value)
        }
      })

      $element.addClass(that.getCurrentBreakpoint())
    }, 250))
  }
}

export default Screenmode
